import React, { Component } from "react";
import lang from "../../lang";
import RechargePop from '../../mall/recharge-pop';
import RechargeResult from "../../mall/recharge-result";
import Cache from 'c-cache';
import { Link } from "react-router";
import Tooltip from 'rc-tooltip';
import qrcode from "../../lib/qrcode";
import SearchUser from '../searchuser/index';
import HeadHistory from '../history/index';
import HeadFollow from '../follow/index';

class Extra extends Component{

    constructor(props) {
        super(props);

        this.state = {
            // isLoggedIn: UP.Global.isLogin(),
            showRechargePop: 0,
            currentPath: '',
        }

        this.cache = new Cache({
            prefix: 'pcuplive'
        });
    }

    componentDidMount() {
        if (this.props.selected !== 'recharge') {
            this.bindEvent();
        }


    }

    bindEvent() {
        // 支付成功
        $.channel.on('rechargeSuccess', (data)=>{
            let diamond = longToString(data.diamond);
            // 更新全局用户信息的U钻数

            UP.Global.updateDiamondBanlance(diamond);

            this.closeRechargePop();

            this.refs.result.showResultSuccess();
        });

        // 支付失败
        $.channel.on('rechargeError', (code)=>{
            this.refs.result.showResultError(code);
        });

        $.channel.on('showRechargePop', ()=>{
            this.showRechargePop();
        });
    }

    componentWillUnmount() {
        $.channel.off('rechargeSuccess');
        $.channel.off('rechargeError');
    }

    showRechargePop=()=> {
        this.setState({
            showRechargePop: 1
        })
    }

    closeRechargePop=()=>{
        this.setState({
            showRechargePop: 0
        });
    }
    /*  <Tooltip getTooltipContainer={()=>this.refs.btns} overlay={<span className="txt">{lang.template('观看记录')}</span>} placement="bottom" trigger={['hover']} overlayClassName="header-mini-popover">
                        <Link className="btn-head history" to="/history">{lang.template('观看记录')}</Link>
                    </Tooltip>
                    <Tooltip getTooltipContainer={()=>this.refs.btns} overlay={<span className="txt">{lang.template('关注')}</span>} placement="bottom" trigger={['hover']} overlayClassName="header-mini-popover">
                        <Link className="btn-head follow" to="/allhostlist/follow">{lang.template('关注')}</Link>
                    </Tooltip>*/

	render(){        
		return (
			<div className="ex-btns ex-expand-btns" ref="btns">
                <SearchUser />
				<div className="btn-head recharge" onClick={this.showRechargePop}>{lang.template('去充值')}</div>
                <HeadHistory/>
                <HeadFollow/>
                {
                    UP.Global.version == 'CN' ? null: (
                        <div className="split"></div>
                    )
                }
                <RechargeResult ref="result"/>
                { this.state.showRechargePop ? <RechargePop onClose={this.closeRechargePop}/> : null }

			</div>
		);
	};
}
module.exports = Extra;



// WEBPACK FOOTER //
// ./js/header/extra/index.js